export function isNull(o: any) {
  return o === undefined || o === null
}

export function isNotNull(o: any) {
  return !isNull(o)
}

export function getValueAtPath(obj, path) {
  if (!obj || typeof obj !== 'object') return undefined

  // Normalize path: convert brackets and unify `/` with `.`
  if (!path) { return null }
  const segments = Array.isArray(path)
    ? path
    : path
        .replace(/\[(\w+)\]/g, '.$1') // convert [key] to .key
        .replace(/\/+/g, '.') // convert / to .
        .replace(/^\./, '') // trim leading dot
        .split('.')

  return segments.reduce((acc, key) => {
    return acc && Object.prototype.hasOwnProperty.call(acc, key) ? acc[key] : undefined
  }, obj)
}

export function setValueAtPath(obj, path, value) {
  if (!obj || typeof obj !== 'object') return

  const segments = Array.isArray(path)
    ? path
    : path
        .replace(/\[(\w+)\]/g, '.$1') // convert [key] to .key
        .replace(/\/+/g, '.') // convert / to .
        .replace(/^\./, '') // remove leading dot
        .split('.')

  let current = obj

  for (let i = 0; i < segments.length; i++) {
    const key = segments[i]
    const isLast = i === segments.length - 1

    if (isLast) {
      current[key] = value
    }
    else {
      // If next key is a number, treat as array
      const nextKey = segments[i + 1]
      const isIndex = /^\d+$/.test(nextKey)

      if (!(key in current) || typeof current[key] !== 'object') {
        current[key] = isIndex ? [] : {}
      }

      current = current[key]
    }
  }
}
